import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Row, Col, Skeleton, InputNumber, Form, Typography, Divider, Space, message } from 'antd';
import {getProporciones, generateProporciones} from '../../../../apis/FiniquitoApi';
import {getLeyByAntiguedad} from '../../../../apis/IntegracionDetalleApi';
import {getAll} from '../../../../apis/IntegracionApi';
import {tipos_fecha} from '../../../../constants/finiquito';
import moment from 'moment';

const { Title } = Typography;

const ModalProporciones = ({ visible, onClose, onSave, bajaData, finiquito, disabled }) => {
    const [loading, setLoading] = useState(false);
    const [diasAcum, setDiasAcum] = useState(0);
    const [menosProgramada, setMenosProgramada] = useState(0);
    const [masProporcionDelAnio, setMasProporcionDelAnio] = useState(0);
    const [totalVacaciones, setTotalVacaciones] = useState(0);
    const [considerados, setConsiderados] = useState(0);
    const [ausentismo, setAusentismo] = useState(0);
    const [incapacidad, setIncapacidad] = useState(0);
    const [diasConsidera, setDiasConsiderar] = useState(0);
    const [diasAntiguedad, setDiasAntiguedad] = useState(0);
    const [diasAPagar, setDiasAPagar] = useState(0);
    

    // useEffect(() => {
    //     setTotalVacaciones(parseFloat(diasAcum.toString()) + parseFloat(menosProgramada.toString()) + parseFloat(masProporcionDelAnio.toString()));
    // }, [diasAcum, menosProgramada, masProporcionDelAnio]);

      useEffect(() => {
        setDiasConsiderar(parseFloat(considerados.toString()) - parseFloat(ausentismo.toString()) - parseFloat(incapacidad.toString()));
    }, [considerados, ausentismo, incapacidad]);


    // useEffect para cargar datos iniciales con estatus 1 (PENDIENTE)
    const effectRan = useRef(false);
    useEffect(() => {
       if (!effectRan.current) {
            (async () => {
                if(!finiquito){
                    setLoading(false);
                    return;
                }

                setLoading(true);
                try {
                    const response = await getProporciones(finiquito.id); // Estatus 1 = PENDIENTE
                
                    if (response.ok) {
                        if(response.payload){
                            setDiasAcum(response.payload.dias_acumulado);
                            setMenosProgramada(response.payload.menos_programada);
                            setMasProporcionDelAnio(response.payload.mas_proporcion_del_anio);
                            setConsiderados(response.payload.considerados);
                            setAusentismo(response.payload.ausentismo);
                            setIncapacidad(response.payload.incapacidad);
                            setDiasConsiderar(response.payload.dias_considera);
                            setDiasAntiguedad(response.payload.dias_antiguedad);
                            setDiasAPagar(response.payload.dias_pagar);
                            setTotalVacaciones(response.payload.total_vacaciones);
                        }else{
                            let diasAntiguedad = 0;
                           
                            if(finiquito.tipo_fecha == tipos_fecha.INGRESO){
                                if(!finiquito.fecha_ingreso){
                                    diasAntiguedad = 0;
                                    message.error("La fecha de ingreso no esta configurada para el empleado")
                                    return;
                                }

                                diasAntiguedad = moment(finiquito.fecha_baja).startOf('day').diff(moment(finiquito.fecha_ingreso).startOf('day'), 'days') + 1;
                            }
                            if(finiquito.tipo_fecha == tipos_fecha.ANTIGUEDAD){
                                if(!finiquito.fecha_baja){
                                    diasAntiguedad = 0;
                                    message.error("La fecha de antiguedad no esta configurada para el empleado");
                                    return;
                                }
                                diasAntiguedad = moment(finiquito.fecha_baja).startOf('day').diff(moment(finiquito.fecha_antiguedad).startOf('day'), 'days') + 1;
                            }

                            let aniosAntiguedad = diasAntiguedad/365;
                            let diasAntiguedadIntegracion = 0;
                            let diasVacacionesIntegracion = 0;
                            const responseIntegration = await getLeyByAntiguedad(aniosAntiguedad);
                            if (responseIntegration.ok) {
                                let payloadIntegration = responseIntegration.payload;
                                diasAntiguedadIntegracion = payloadIntegration.dias_aguinaldo;
                                diasVacacionesIntegracion = payloadIntegration.dias_vacaciones;
                            }

                            const proporcionVacaciones = (diasAntiguedad*diasVacacionesIntegracion)/365;
                            const proporcionAguinaldo = (diasAntiguedad*diasAntiguedadIntegracion)/365;
                            setDiasAntiguedad(diasAntiguedadIntegracion);
                            setMasProporcionDelAnio(proporcionVacaciones);
                            setTotalVacaciones(proporcionVacaciones);

                            //if finiquito.fecha < firstDay, tomo la mas reciente
                            const firstDay = moment().startOf('year');
                            const fechaEntryDate = moment(finiquito.fecha);
                            let fechaReal;
                            if (fechaEntryDate.isAfter(firstDay)) {
                                fechaReal = fechaEntryDate;
                            } else {
                                fechaReal = firstDay;
                            }
                            const _considerados = moment(finiquito.fecha_baja).startOf('day').diff(fechaReal.startOf('day'), 'days');
                            setConsiderados(_considerados);

                            //es considerados - ausentismo - incapacidades
                            //setDiasConsiderar(daysConsiderados);

                            const _diasAPagar = (_considerados*diasAntiguedadIntegracion)/365;
                            setDiasAPagar(_diasAPagar);

                            //Dias a pagar
                            //( Dis considerados * dias de aguinaldo integracion ) / 365
                        }
                    
                    }
                } catch (error) {
                message.error('Error en la consulta inicial');
                } finally {
                setLoading(false);
                }
             })();
        }
        return () => effectRan.current = true;
    }, [finiquito]);

    const handleSave = async () => {
        const data = {
            finiquito_id: finiquito.id,
            dias_acumulado:diasAcum,
            menos_programada:menosProgramada,
            mas_proporcion_del_anio:masProporcionDelAnio,
            total_vacaciones: totalVacaciones,
            considerados,
            ausentismo,
            incapacidad,
            dias_considera:diasConsidera,
            dias_antiguedad:diasAntiguedad,
            dias_pagar:diasAPagar
        };
        
        let response = await generateProporciones(data);
        if(response.ok){
            message.success('Se guardo correctamente las proporciones!');
            if (onSave) {
                onSave(data);
            }
        }
    };


    return (
        <Modal
            title="Proporciones"
            open={visible}
            onCancel={onClose}
            width={800}
            footer={[
                <Button key="close" onClick={onClose}>
                    Cancelar
                </Button>,
                <Button key="save" type="primary" onClick={handleSave} disabled={disabled}>
                    Guardar
                </Button>
            ]}
            destroyOnClose
        >

        {
            loading ? <Skeleton loading={loading}/>:
            <>
                <Row gutter={24}>
                    {/* Sección Vacaciones */}
                    <Col span={12}>
                        <Title level={4} style={{ textAlign: 'center', color: '#2E2D75' }}>
                            VACACIONES
                        </Title>
                        <Divider style={{ margin: '12px 0 20px 0' }} />
                        
                        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                            <Row>
                                <Col span={12}>
                                    <span>Días Acum:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={diasAcum}
                                        onChange={(e) => setDiasAcum(e)}
                                        style={{ textAlign: 'right' }}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <span>Menos Programada:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={menosProgramada}
                                        onChange={(e) => setMenosProgramada(e)}
                                        style={{ textAlign: 'right' }}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <span>Más Proporción del:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={masProporcionDelAnio}
                                        onChange={(e) => setMasProporcionDelAnio(e)}
                                        style={{ textAlign: 'right' }}
                                        status="warning"
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Divider dashed />
                            <Row>
                                <Col span={12}>
                                    <strong>Total:</strong>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={totalVacaciones}
                                        onChange={(e) => setTotalVacaciones(e)}
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                        status="success"
                                        disabled={disabled}
                                    />
                                    {/* <span style={{ textAlign: 'right', fontWeight: 'bold' }}>{totalVacaciones}</span> */}
                                </Col>
                            </Row>
                        </Space>
                    </Col>

                    {/* Sección Aguinaldo */}
                    <Col span={12}>
                        <Title level={4} style={{ textAlign: 'center', color: '#2E2D75' }}>
                            AGUINALDO
                        </Title>
                        <Divider style={{ margin: '12px 0 20px 0' }} />
                        
                        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                            <Row>
                                <Col span={12}>
                                    <span>Considerados:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={considerados}
                                        onChange={(e) => setConsiderados(e)}
                                        style={{ textAlign: 'right' }}
                                        status="warning"
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col span={12}>
                                    <span>Ausentismo:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={ausentismo}
                                        onChange={(e) => setAusentismo(e)}
                                        style={{ textAlign: 'right' }}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col span={12}>
                                    <span>Incapacidad:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={incapacidad}
                                        onChange={(e) => setIncapacidad(e)}
                                        style={{ textAlign: 'right' }}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            
                            <Divider dashed />
                            
                            <Row>
                                <Col span={12}>
                                    <span>Días Considera:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={diasConsidera}
                                        onChange={(e) => setDiasConsiderar(e)}
                                        style={{ textAlign: 'right' }}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col span={12}>
                                    <span>Días Antig:</span>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={diasAntiguedad}
                                        onChange={(e) => setDiasAntiguedad(e)}
                                        style={{ textAlign: 'right' }}
                                        disabled={disabled}
                                        // disabled={true}
                                    />
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col span={12}>
                                    <strong>Días a Pagar:</strong>
                                </Col>
                                <Col span={12}>
                                    <InputNumber
                                        value={diasAPagar}
                                        onChange={(e) => setDiasAPagar(e)}
                                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                                        status="success"
                                        disabled={disabled}
                                    />
                                </Col>
                            </Row>
                        </Space>
                    </Col>
                </Row>
            </>
        }
        </Modal>
    );
};

export default ModalProporciones;